module.exports = __webpack_public_path__ + "static/img/gyzxfw@2x.92be68d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gyzxfw@2x.png
// module id = UUQQ
// module chunks = 2